import WarningIcon from "../../assets/images/warning-icon.png";
import {ReactNode} from "react";

interface SystemBannerProps {
    title: string;
    icon?: string;
    subtitle: string;
    actions?: ReactNode | ReactNode[];
    rtl?: boolean;
    bannerImage?: string;
}

const SystemBanner = ({ title, subtitle, actions, icon = WarningIcon, rtl = false, bannerImage }: SystemBannerProps) => {
    return <div>
        <div className={`instructions-banner-container${rtl ? " instructions-banner-rtl" : ""}${bannerImage ? " instructions-banner-with-image" : ""}`} dir={rtl ? "rtl" : "ltr"}>
            {bannerImage && <div className="banner-image-wrapper"><img className="banner-top-image" src={bannerImage} alt="" /></div>}
            <div className="banner-body">
                <div className="content-container">
                    <img className="warning-icon" src={icon} alt="Warning" />
                    <div className="content">
                        <div className="title">{title}</div>
                        <div className="subtitle">{subtitle}</div>
                    </div>
                </div>
                <div className="actions">
                    {actions}
                </div>
            </div>
        </div>
    </div>;
}

export default SystemBanner;